import angular from 'angular';
import {auth} from './auth/auth.js';
import {common} from './common/common.js';
import {dashboard} from './dashboard/dashboard.js';
import {ordinacija} from './ordinacija/ordinacija.js';
import {cjenik} from './cjenik/cjenik.js';
import {radniNalog} from './radniNalog/radniNalog.js';
import {stavkaNaloga} from './stavkaNaloga/stavkaNaloga.js';
import {fazaNaloga} from './fazaNaloga/fazaNaloga.js';

const components = angular.module('components', [
    auth.name,
    common.name,
    dashboard.name,
    ordinacija.name,
    cjenik.name,
    radniNalog.name,
    stavkaNaloga.name,
    fazaNaloga.name
]);


export {components};



// WEBPACK FOOTER //
// ./app/components/components.js